import React, { useState } from "react";
import { Row, Col, Card, Divider, Input } from "antd";
import "./index.css";
import Tabs from "../../components/tab/index";
import {
  AiOutlineSearch,
  BsCalendarMinus,
  BsExclamationLg,
} from "react-icons/all";
import TableWrapper from "../Grid";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { GrClose } from "react-icons/gr";
import { numberWithCommas } from "../../../plant_dir/config/utils";
import { formatToNumber } from "../../config/utils";
export default function PlantOrder({
  Orders,
  onChangeTab,
  metaData,
  currentPage,
  previousPage,
  onChangeText,
  isLoader,
  searchValue,
  onClearSearch,
}) {
  const [isClose, setIsclose] = useState(false);
  const history = useHistory();

  const columns = [
    {
      title: "ORDER DETAILS",
      dataIndex: "",
      align: "left",
      sortDirections: ["descend", "ascend"],
      key: "rmx_product",
      className: "action-class",
      width: 20,
      sorter: (a, b) => a.order_number.localeCompare(b.order_number),
      render: (r) => {
        return (
          <div className="order-width">
            <h3 className="font-w-700">{`Order# ${r?.order_number}`}</h3>
            {r.order_products.map((item, index) => {
              return (
                <span key={index}>
                  {" "}
                  {(index ? "," : "") + item?.rmx_product?.name}
                </span>
              );
            })}
          </div>
        );
      },
    },
    {
      title: "CONTRACTOR",
      dataIndex: "",
      align: "left",
      key: "first_name",
      className: "action-class",
      width: 20,
      sorter: (a, b) =>
        a.contractor?.user?.first_name.localeCompare(
          b.contractor?.user?.first_name
        ),
      render: (r) => {
        return (
          <div>
            <h3 className="font-w-700">{`${r?.contractor?.user?.first_name} ${r?.contractor?.user?.last_name}`}</h3>
            <p>{formatToNumber(r?.contractor?.user?.phone)}</p>
          </div>
        );
      },
    },
    {
      title: "DATE",
      dataIndex: "",
      align: "left",
      className: "action-class",
      width: 20,
      sorter: (a, b) =>
        a?.preferred_delivery_datetime.localeCompare(
          b?.preferred_delivery_datetime
        ),
      render: (r) => (
        <div class="chip chips-s">
          <span class="pm-circle am-pm-circle">
            {r?.preferred_delivery_period == "am" ? (
              <BsExclamationLg color="red" size={18} />
            ) : (
              <BsExclamationLg color="grey" size={18} />
            )}
          </span>
          <span style={{ marginRight: "5px" }}>
            <BsCalendarMinus size="12" />
          </span>
          <span>
            {moment(r?.preferred_delivery_datetime).format("MM-DD-YYYY")}
          </span>
        </div>
      ),
    },
    {
      title: "PRICE",
      dataIndex: "",
      align: "left",
      className: "action-class",
      width: 20,
      sorter: (a, b) => a?.total_amount.localeCompare(b?.total_amount),
      render: (r) => <p>{`
        ${r?.order_credit_purchase?.order_credit_purchase?.invoice?.order?.currency || "$"}
        ${numberWithCommas(Number(r?.total_amount)?.toFixed(2))}`}</p>,
    },
    {
      title: "PO#",
      dataIndex: "",
      align: "left",
      width: "20%",
      className: "action-class",
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => a.order_number.localeCompare(b.order_number),
      key: "purchase_order_num",
      render: (r) => (
        // if(r.purchaseOrder)
        <p className="">
          {
            r?.purchase_order_num ? r?.purchase_order_num : "-"
          }
        </p>
      ),
    },
    {
      title: "ACTION",
      dataIndex: "",
      align: "left",
      className: "action-class",
      width: 20,
      render: (r) => (
        <p
          className="st-primary pointer-cursor "
          onClick={() => history.push(`/order/${r.id}`)}
        >
          Details
        </p>
      ),
    },
  ];

  return (
    <>
      <Row justify="start">
        <Col
          xs={24}
          sm={24}
          md={24}
          lg={24}
          xl={24}
          style={{ marginTop: "1.6em" }}
        >
          <Row justify="start">
            <Col xs={24} sm={24} md={24} lg={24} xl={24} className="custom ">
              <Card
                style={{
                  padding: "1rem",
                  boxShadow: "0px 0px 5px 0px rgb(0 0 0 / 16%)",
                  border: "1px solid #f7f7f7",
                }}
              >
                <Row justify="space-between">
                  <Col xl={12} xs={24} sm={24} md={10} lg={12}>
                    <Row>
                      <Col xl={24} xs={24} sm={18} md={17}>
                        <h5 className="text-left"> Order Queue</h5>
                      </Col>
                    </Row>
                  </Col>
                  <Col style={{ display: "flex" }}>
                    <AiOutlineSearch
                      size="25"
                      onClick={() => {
                        setIsclose(!isClose);
                        onClearSearch();
                      }}
                      className="pointer-cursor"
                      style={{ marginRight: "5px" }}
                    />
                    <Input
                      placeholder="Search..."
                      style={{
                        width: isClose ? "150px" : "0px",
                        padding: 3,
                        background: "transparent",
                        border: "none",
                        borderBottom: "none",
                      }}
                      onChange={onChangeText}
                      value={searchValue}
                    />
                    {isClose && (
                      <GrClose
                        size="20"
                        onClick={() => setIsclose(!isClose)}
                        style={{ marginRight: "20px" }}
                        className="pointer-cursor"
                      />
                    )}
                  </Col>

                  <Divider
                    className="ant-divider-horizontal"
                    orientation="right"
                  ></Divider>
                </Row>
                <Row>
                  <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                    <Tabs
                      onChangeTab={onChangeTab}
                      plantData={[
                        {
                          key: "PENDING",
                          component: () => (
                            <TableWrapper
                              tableData={Orders}
                              tableColumns={columns}
                              metaData={metaData}
                              currentPage={currentPage}
                              previousPage={previousPage}
                              isLoader={isLoader}
                              fromOrder={true}
                            />
                          ),
                        },
                        {
                          key: "INPROGRESS",
                          component: () => (
                            <TableWrapper
                              tableData={Orders}
                              tableColumns={columns}
                              metaData={metaData}
                              currentPage={currentPage}
                              previousPage={previousPage}
                              isLoader={isLoader}
                              fromOrder={true}
                            />
                          ),
                        },

                        {
                          key: "COMPLETED",
                          component: () => (
                            <TableWrapper
                              tableData={Orders}
                              tableColumns={columns}
                              metaData={metaData}
                              currentPage={currentPage}
                              previousPage={previousPage}
                              isLoader={isLoader}
                              fromOrder={true}
                            />
                          ),
                        },
                      ]}
                    />
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
}
